import { useState, useEffect, useCallback } from 'react';
import { SecureGet, SecurePost, SecurePut } from '../services/axiosCall';
import apis from '../services/Apis';
import { getRandomId } from '../utilities/randomId';


const useEvaluationSemester = ({
  url,
  formId,
  // userDetails,
  selectedYear,
  messageApi,
  convertToTableData,
  convertToRequestData,
  convertPlanningToRequestData
}) => {


  // State to store the unique identifier for the plan
  // const [id, setId] = useState(null);
  // const handleId = (id) => setId(id);

  const [fetchLoading, setFetchLoading] = useState(false);
  const handleFetchLoading = (loading) => setFetchLoading(loading);


  const [semesterLoading, setSemesterLoading] = useState({});
  const handleSemesterLoading = (semester, type, loading) => {
    setSemesterLoading((prev) => ({
      ...prev,
      [semester]: {
        ...prev[semester],
        [type]: loading,
      },
    }));
  };

  const [planing, setPlaning] = useState([]);
  const handlePlaning = (plan) => setPlaning(plan);

  const [semesterComments, setSemesterComments] = useState({});
  const [cumulativeApaPoints, setCumulativeApaPoints] = useState(0)


  const ensureThreeSemesters = useCallback((planningData) => {
    const allSemesters = [1, 2, 3];
    let temp = [...planningData];

    allSemesters.forEach((semester) => {
      if (!temp.some((item) => item.semester === semester)) {
        temp.push({
          semester: semester,
          courses: [],
          apa_point: 0,
          data: [],
          tempSemester: getRandomId()
        });
      }
    });

    return temp.map((item) => ({
      ...item,
      courses: item.data || []
    })).sort((a, b) => a.semester - b.semester);
  }, []);

  // Function to fetch planning data
  const fetchPlaning = useCallback((year, formId) => {
    handlePlaning([]);
    handleFetchLoading(true);

    SecureGet({
      url: `${url}`,
      params: {
        year,
        apa_form: formId,
      },
    })
      .then((response) => {
        let planningData = response.data.results || [];

        if (planningData.length) {
          // Set planning data if available
          planningData = convertToTableData ? convertToTableData(response.data) : planningData;
          handlePlaning(ensureThreeSemesters(planningData));
          handleFetchLoading(false);

          // Set plan identifier
          // handleId(
          //   response.data.results &&
          //     response.data.results.length &&
          //     response.data.results[0].id
          //     ? response.data.results[0].id
          //     : null
          // );
          // Extract and set comments for each semester
          const comments = {};
          planningData.forEach((plan) => {
            comments[plan.semester] = plan.comment || ''; // Assuming `comment` field exists
          });
          setSemesterComments(comments);

          if (response.data.results[0]?.status === 3)
            calculatePlaning(response.data.results[0].apa_form)

        } else {
          // If no planning data, fetch from a different API endpoint
          SecureGet({
            url: `${apis.PLANING}`,
            params: {
              year,
              apa_form: formId,
            },
          })
            .then((response) => {
              const planningResults = response.data.results || [];
              // const planningResults = response.data.results;
              if (planningResults.length) {
                // Convert planning data for the table
                const convertedData = convertPlanningToRequestData(planningResults[0].planning, year, formId);

                // Post the converted data to create semester-wise data
                const postDataPromises = convertedData.map((data) => SecurePost({ url: `${url}`, data: { ...data }, }));

                Promise.all(postDataPromises)
                  .then(() => {
                    fetchPlaning(year, formId); // Re-fetch the planning data
                    handleFetchLoading(false);
                  })
                  .catch((error) => {
                    handleFetchLoading(false);
                    console.error('Error creating semester-wise data:', error);
                  });

                // Set planning data for the table
                handlePlaning(ensureThreeSemesters(convertToTableData({ results: planningResults[0].planning })));
                calculatePlaning(formId)

              } else {
                handlePlaning(ensureThreeSemesters([]));
                handleFetchLoading(false);
              }
            })
            .catch(() => {
              handlePlaning(ensureThreeSemesters([]));
              handleFetchLoading(false);
            });
        }
      })
      .catch(() => {
        handlePlaning(ensureThreeSemesters([]));
        handleFetchLoading(false);
      });
  }, []);

  const updatePlaning = (semester) => {
    const semesterPlan = planing.find((plan) => plan.semester === semester);
    if (!semesterPlan) return;

    handleSemesterLoading(semester, 'updateLoading', true);

    const newPlan = {
      apa_form: formId,
      year: selectedYear,
      semester: semester,
      json: convertToRequestData ? convertToRequestData(planing, selectedYear, formId, semester).json : planing,
      // user: userDetails,
    };

    if (semesterPlan.id) {
      SecurePut({
        url: `${url}/${semesterPlan.id}`,
        data: { ...newPlan },
      })
        .then(() => {
          fetchPlaning(selectedYear, formId);
          calculatePlaning(formId)
          
          handleSemesterLoading(semester, 'updateLoading', false);
          messageApi.success('Successfully updated');
        })
        .catch((error) => {
          handleSemesterLoading(semester, 'updateLoading', false);
          const { response } = error;
          const { data } = response || {};
          const { error: errorMsg } = data || {};

          if (errorMsg)
            messageApi.open({
              type: 'error',
              content: errorMsg,
              duration: 5,
              style: {
                fontWeight: 'bold',
                fontSize: '15px',
              },
              className: 'custom-error-message',
            });
          else
            messageApi.open({
              type: 'error',
              content: 'Something went wrong',
              duration: 5,
              style: {
                fontWeight: 'bold',
                fontSize: '15px',
              },
              className: 'custom-error-message',
            });
        });
    } else {
      SecurePost({
        url: `${url}`,
        data: { ...newPlan },
      })
        .then(() => {
          fetchPlaning(selectedYear, formId);

          handleSemesterLoading(semester, 'updateLoading', false);
          calculatePlaning(formId)
          messageApi.success('Successfully updated');
        })
        .catch((error) => {
          handleSemesterLoading(semester, 'updateLoading', false);
          const { response } = error;
          const { data } = response || {};
          const { error: errorMsg } = data || {};

          if (errorMsg)
            messageApi.open({
              type: 'error',
              content: errorMsg,
              duration: 5,
              style: {
                fontWeight: 'bold',
                fontSize: '15px',
              },
              className: 'custom-error-message',
            });
          else
            messageApi.open({
              type: 'error',
              content: 'Something went wrong',
              duration: 5,
              style: {
                fontWeight: 'bold',
                fontSize: '15px',
              },
              className: 'custom-error-message',
            });
        });
    }
  };

  const calculatePlaning = (ID) => {

    if (ID) {
      SecureGet({
        url: `${apis.CUMUlATIVE_APA}/${ID}/${selectedYear}`,
      })
        .then((response) => {
          setCumulativeApaPoints(response?.data)
          // messageApi.success('Successfully updated');
        })
        .catch((error) => {

          const { response } = error;
          const { data } = response || {};
          const { error: errorMsg } = data || {};

          if (errorMsg) messageApi.error(errorMsg);
          else messageApi.error("Something went wrong")
        });
    }
  }

  const evaluatePlaning = (semester) => {

    const semesterPlan = planing.find((plan) => plan.semester === semester);
    if (!semesterPlan) return;

    handleSemesterLoading(semester, 'evaluateLoading', true);

    const newPlan = {
      id: semesterPlan.id,
      status: 3,
      type: 2
    };

    if (semesterPlan.id) {
      SecurePost({
        url: `${apis.EVALUATION_FORM}`,
        data: { ...newPlan },
      })
        .then(() => {
          fetchPlaning(selectedYear, formId);
          // setStatus(response?.data?.results[0]?.status)
          handleSemesterLoading(semester, 'evaluateLoading', false);
          messageApi.success('Evaluation updated successfully');
        })
        .catch((error) => {
          handleSemesterLoading(semester, 'evaluateLoading', false);
          const { response } = error;
          const { data } = response || {};
          const { error: errorMsg } = data || {};

          if (errorMsg) messageApi.error(errorMsg);
          else messageApi.error("Something went wrong")
        });
    }
  }

  useEffect(() => {
    if (formId && selectedYear) {
      fetchPlaning(selectedYear, formId);
      calculatePlaning(formId)
    }
  }, [fetchPlaning, formId, selectedYear]);


  return {
    planing,
    fetchLoading,
    updatePlaning,
    handlePlaning,
    evaluatePlaning,
    cumulativeApaPoints,
    semesterLoading,
    semesterComments
  };
};

export default useEvaluationSemester;
